import React from 'react';
import styled from 'styled-components';
import Hero from 'components/Hero';
import { Content } from 'components/Layout';
import HeroBgImage from 'assets/img/peptides_based_drugs.png';

const PeptideBasedDrugsOverview = () => {
  const title = 'Peptide Based Drugs';
  const subtitle = `Accelerating Next-Generation Peptide Therapeutics Through Sequence-Based AI and Structural Modeling`;

  return (
    <PeptideBasedDrugs>
      <Hero title={title} subtitle={subtitle} bgImage={HeroBgImage} />
      <Content>
        <p>Genion Quantum Tech has developed a sequence-based AI generation platform tailored for peptide drug discovery, seamlessly integrated with structure-based modeling to refine activity and optimize therapeutic potential. This unique integration not only accelerates the design of novel therapeutic peptides but also enhances their efficacy, stability, and bioavailability.</p>
        <p>By bridging AI-driven sequence innovation with rational structural optimization, Genion Quantum Tech empowers pharmaceutical partners to expand peptide chemical space, reduce R&D timelines, and unlock new opportunities in areas with high unmet needs for peptide-based drugs.</p>
        <p>In addition, Genion Quantum Tech has independently developed proprietary algorithms and technologies for the analysis of protein–protein interactions (PPIs), further enhancing capabilities in rational drug design and target discovery.</p>
      </Content>
    </PeptideBasedDrugs>
  );
};

const PeptideBasedDrugs = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default PeptideBasedDrugsOverview;